import React from 'react'
import { TaskListItem } from '@myapp/contract'
import { getTaskColors } from './timelineConstants'
import { getTaskTypeLabel } from '../../../entities/task'

interface Props {
  task: TaskListItem
  onClick?: () => void
  onDragStart?: (task: TaskListItem, e: React.MouseEvent) => void
  isDragging?: boolean
}

export const DayLevelTaskBanner = ({ task, onClick, onDragStart, isDragging }: Props) => (
  <div
    className={`flex items-center gap-2 px-3 h-6 text-white text-xs font-medium truncate ${
      isDragging ? 'opacity-30' : 'hover:brightness-95'
    } ${onDragStart ? 'cursor-grab' : 'cursor-pointer'}`}
    style={{ backgroundColor: getTaskColors(task.status).workColor }}
    onClick={onClick}
    onMouseDown={onDragStart ? (e) => {
      e.stopPropagation()
      onDragStart(task, e)
    } : undefined}
    title={`${getTaskTypeLabel(task.taskType)}: ${task.title}`}
  >
    <span className="opacity-80 shrink-0">{getTaskTypeLabel(task.taskType)}:</span>
    <span className="truncate">{task.title}</span>
  </div>
)
